var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dsh-tip",class:{ 'is-on': _vm.show && !_vm.dismissed },style:(_vm.style),attrs:{"aria-hidden":"true"}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }